/**
 * UI preferences — chrome state that outlives a reload and belongs to no single
 * screen.
 *
 * Today it holds one thing: whether the desktop rail (DS-05) is collapsed. It is
 * persisted because a receptionist who hides the rail for a wide table does not
 * want it back on every refresh. The drawer on a phone (NFR-05) is unaffected:
 * it is transient, so its open/closed state stays local to `AppShell`.
 */

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UiState {
  /** DS-05 — collapsed hides the rail entirely; the menu bar still offers the toggle. */
  sidebarCollapsed: boolean;
  toggleSidebar: () => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
}

export const useUiStore = create<UiState>()(
  persist(
    (set) => ({
      sidebarCollapsed: false,
      toggleSidebar: () => set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
      setSidebarCollapsed: (sidebarCollapsed) => set({ sidebarCollapsed }),
    }),
    { name: 'nova-ui' },
  ),
);
